import LoggedOutHomepage from '@fiverr-private/header/entries/LoggedOutHomepage';

export default LoggedOutHomepage;
